// extracted by mini-css-extract-plugin
export default {"checkbox":"_3wu9S","label":"JcHn1","disabled":"_1WGiV"};